import type { AnySceneObjectT } from "tweenly"
import { useCallback } from "react"
import { selectUndoable } from "../helpers/selector.helpers"
import { useAppSelector } from "./useRedux"

const useObject = () => {
    const objectsById = useAppSelector((state) => selectUndoable(state).objects.value)
    /**
     * find object by id from objects
     *
     * `objects.value` is already keyed by id, so the old `Object.values(...).find(...)` scan
     * was an O(n) walk per lookup — and several call sites run it once per selected object.
     */
    const findObjectById = useCallback(
        (id: string): AnySceneObjectT | undefined => objectsById[id],
        [objectsById]
    )
    return { findObjectById }
}

export default useObject
